import * as type from '@/utvStore/store/mutation-types'
import { COMMENT_API } from '@/utvStore/store/API'

const axiosInstance = axios.create({
  timeout: 8000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

const initialState = {
  commentData: [],
  pointAve: 0,
  topStarData: []
}
const state = Object.assign({}, initialState)

const getters = {}

const actions = {
  // 一覧取得
  [type.GET_COMMENT_LIST]({ commit }, params) {
    Object.assign(params, { point_ave: 1 }) //point_aveフラグを立てる
    return axiosInstance.get(COMMENT_API.getCommentList, { params }).then(
      res => {
        if (res.data.data.hasOwnProperty('point_ave')) {
          commit(type.SET_POINT_AVE, parseFloat(res.data.data['point_ave']))
          delete res.data.data['point_ave']
        }
        commit(type.GET_COMMENT_LIST, res.data)
      },
      error => {
        return Promise.reject(error)
      }
    )
  },
  [type.GET_TOP_STAR_LIST]({ commit }) {
    return axiosInstance.get(COMMENT_API.getTopStarList).then(
      res => {
        commit(type.GET_TOP_STAR_LIST, res.data)
      },
      error => {
        return Promise.reject(error)
      }
    )
  }
}

const mutations = {
  [type.GET_COMMENT_LIST](_state, commentData) {
    Object.assign(_state, { commentData })
  },
  [type.SET_POINT_AVE](_state, pointAve) {
    Object.assign(_state, { pointAve })
  },
  [type.GET_TOP_STAR_LIST](_state, topStarData) {
    Object.assign(_state, { topStarData })
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/commentView.js